import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * XEA Input — large, soft-pill input with ink focus ring (no blue browser ring).
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-2xl border border-transparent bg-ink-100 px-5 text-sm text-ink-950 transition-all duration-200",
        "placeholder:text-ink-500 placeholder:font-light",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink-950",
        "focus:outline-none focus:bg-white focus:border-ink-950 focus:shadow-[0_0_0_4px_rgba(10,10,10,0.06)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
